<template>
  <main class="tests">
    <!-- <div class="left-side">
      <MetaHead/>
      <sidebar/>
    </div> -->
    <!-- <div class="test-container">
      <router-view/>
    </div> -->
    <!-- {{hideEmpty}} -->
    <!-- <MobileSidebarWrapper param="test" v-if="hideEmpty || haveTests.water || haveTests.tissue || haveTests.soil"> -->
      <MobileSidebarWrapper param="test">

      <template slot="sidebar">
        <div class="left-side">
          <MetaHead/>
          <sidebar/>
        </div>
      </template>



      <template slot="content">



        <div class="test-container">
          <router-view/>

        </div>
      </template>

    </MobileSidebarWrapper>

    <!-- <div class="empty" :class="{hidden: hideEmpty}" v-if="!haveTests.water || !haveTests.tissue || !haveTests.soil">

      <empty-content :title="$ml.get('You still don\'t have tests!')">
        <template v-slot:content>
          <app-btn @click="openModal">{{ $ml.get(`ADD TEST`) }}</app-btn>
        </template>
      </empty-content>

    </div> -->




    <transition name="modal-fade-scale">
      <CreateTestModal v-if="$store.getters['tests/isCreateModalOpened']"/>
    </transition>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/components/tests/sidebar/Sidebar'
import MetaHead from '@/components/tests/sidebar/MetaHead'
import CreateTestModal from '@/components/tests/create-test-modal/CreateTestModal'
import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'
export default {
  components: {
    Sidebar,
    MetaHead,
    CreateTestModal,
    MobileSidebarWrapper
  },
  computed: {
    ...mapGetters({
      haveTests: 'tests/sidebar/haveTests',
    }),
  },
  data() {
    return {
      hideEmpty: false,
    }
  },
  methods: {
    openModal() {
      this.hideEmpty ^= true;
      this.$store.commit('tests/openCreateModal');
    },
  },
  created() {
    this.$store.dispatch('tests/sidebar/checkIfHaveTests');
  }
}
</script>

<style lang="scss" scoped>

.tests {
  padding: 0 8px;

  .left-side {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .test-container {
    padding-left: 8px;
    width: 100%;
    @media(max-width:768px) {
      padding: 0;
      .soil-test-single::v-deep {
        .test-details {
          .inbody {
            .form {
              .test-details-top, .test-details-bottom {
                .item {
                  width: 100%;
                }
              }
            }
          }
        }
      }
      .water-test-single::v-deep, .tissue-test-single::v-deep {
        .inbody {
          .form {
            .item {
              width: 100%;
            }
          }
        }
      }
      main::v-deep {
        .meta-head {
          min-height: unset;
          .wrapper {
            align-items: flex-start;
            .title {
              display: none;
            }
            .buttons {
              width: 100%;
              justify-content: space-between;
              .save {
                margin-right: 0;
              }
              .delete {
                margin-right: 0;
              }
            }
          }
        }
        .inbody {

        }
      }
    }
  }
}

</style>
